import { DOCUMENT } from '@angular/common';
import { Injectable, afterNextRender, inject } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Browser } from '../push-notifications';
import { isPWA } from '../util';

@Injectable()
export class ViewportFixService {
  private window = inject(WINDOW, { optional: true });
  private document = inject(DOCUMENT, { optional: true });
  private deviceService = inject(DeviceDetectorService);
  private deviceInfo = this.deviceService.getDeviceInfo();
  private browser = this.deviceInfo.browser as Browser;

  constructor() {
    afterNextRender(() => {
      const window = this.window;
      const document = this.document;
      const hasVirtualKeyboard =
        this.deviceService.isMobile() || this.deviceService.isTablet();

      if (!window || !document || !hasVirtualKeyboard) {
        return;
      }

      if (this.browser === 'Chrome') {
        this.fixChrome();
      } else {
        this.fixOther();
      }
    });
  }

  private fixChrome() {
    const window = this.window;
    const document = this.document;
    if (!document || !window) {
      return;
    }

    const initialHeight = document.body.offsetHeight;
    document.body.style.height = `${initialHeight}px`;

    const isPwa = isPWA();

    const fixBottomSpacing = () => {
      const viewportHeight = this.window?.visualViewport?.height;
      if (viewportHeight == null) {
        return;
      }

      const diff = viewportHeight - initialHeight;

      if (diff < 0) {
        // happens when textarea is touched and keyboard shows up
        const adjustedHeight = initialHeight + diff;
        this.setHeight(adjustedHeight);
        if (isPwa) {
          document.body.style.paddingBottom = `24px`;
        }
        // document.documentElement.style.scrollSnapType = 'y mandatory';
        // document.body.style.scrollSnapAlign = 'end';
      } else if (diff > 0 && diff < 2) {
        return;
      } else if (diff > 2) {
        this.setHeight(initialHeight);
        if (isPwa) {
          document.body.style.paddingBottom = `0`;
        }
      } else {
        this.setHeight(initialHeight);
      }
    };

    window.addEventListener('resize', fixBottomSpacing);
  }

  private fixOther() {
    const visualViewport = window.visualViewport;
    if (!visualViewport) {
      return;
    }

    visualViewport.onresize = () => {
      this.setHeight(visualViewport.height);
    };
  }

  private setHeight(height: number) {
    const document = this.document;
    if (!document) {
      return;
    }

    document.body.style.height = `${height}px`;
    document.documentElement.style.height = `${height}px`;
  }
}
